import React, { useEffect } from 'react';

import { useSelector, useDispatch } from 'react-redux';
import { setShowToast, selectShowToast, selectSelectedToast } from '_redux/slices/timeline/timeline-toast';

import { IoMdInformationCircleOutline } from "react-icons/io";
import { MdOutlineCheckCircle, MdOutlineErrorOutline } from "react-icons/md";

const VARIANTS = {
    success: { bg: '#f0fdf4', border: '#22c55e', icon: '#16a34a', text: '#14532d', Icon: MdOutlineCheckCircle },
    failed:  { bg: '#fff1f2', border: '#f43f5e', icon: '#e11d48', text: '#881337', Icon: MdOutlineErrorOutline },
    pending: { bg: '#fffef0', border: '#eab308', icon: '#ca8a04', text: '#713f12', Icon: IoMdInformationCircleOutline },
};

const DISMISS_MS = { success: 5000, failed: 5000, pending: 8000 };

const CustomToast = () => {
    const dispatch  = useDispatch();
    const showToast = useSelector(selectShowToast);
    const { message, statusType } = useSelector(selectSelectedToast);

    const v = VARIANTS[statusType] || VARIANTS.pending;
    const ms = DISMISS_MS[statusType] || 5000;

    useEffect(() => {
        if (!showToast) return;
        const t = setTimeout(() => dispatch(setShowToast(false)), ms);
        return () => clearTimeout(t);
    }, [showToast, statusType]);

    if (!showToast) return null;

    const { Icon } = v;

    return (
        <div style={{
            width:        320,
            background:   v.bg,
            border:       `1.5px solid ${v.border}`,
            borderRadius: 8,
            padding:      '12px 14px',
            display:      'flex',
            alignItems:   'flex-start',
            gap:          10,
            boxShadow:    '0 4px 16px rgba(0,0,0,0.12)',
            animation:    'toast-in 0.2s ease',
            fontFamily:   'Arial, sans-serif',
            position:     'relative',
            overflow:     'hidden',
        }}>
            <Icon size={18} color={v.icon} style={{ flexShrink: 0, marginTop: 1 }} />
            <span style={{ fontSize: 13, fontWeight: 500, color: v.text, flex: 1, lineHeight: 1.4 }}>
                {message}
            </span>
            <button
                onClick={() => dispatch(setShowToast(false))}
                style={{ background: 'none', border: 'none', color: '#9ca3af', cursor: 'pointer', fontSize: 16, lineHeight: 1, padding: 0, flexShrink: 0 }}
            >
                ×
            </button>

            {/* progress bar */}
            <div style={{ position: 'absolute', bottom: 0, left: 0, right: 0, height: 3, background: 'rgba(0,0,0,0.06)' }}>
                <div style={{ height: '100%', background: v.border, animation: `toast-progress ${ms}ms linear forwards` }} />
            </div>

            <style>{`
                @keyframes toast-in { from { opacity: 0; transform: translateX(20px); } to { opacity: 1; transform: none; } }
                @keyframes toast-progress { from { width: 100%; } to { width: 0%; } }
            `}</style>
        </div>
    );
};

export default CustomToast;

